import React from "react";
import { Outlet } from "react-router-dom";

function Billing() {
    return (
        <section className="section-bg-color setting_tab"
            style={{ minHeight: "calc(100vh - 0px)", overflowX: 'hidden', }}>
            <div className="custom_container ">
                <div className="row">
                    <div className="col-12">
                        <div className="tab-content" id="nav-tabContent"
                            style={{ minHeight: 'calc(100vh - 259px)', marginBottom: '30px' }}>

                            <Outlet />

                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Billing;